module.exports = __webpack_public_path__ + "static/media/the-big-three.2890492a.jpg";